// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OperaOutlinedSvg from "@fishx/icons-svg/es/asn/OperaOutlined";
import FishxIcon from '../components/FishxIcon';

var OperaOutlined = function OperaOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: OperaOutlinedSvg
  }));
};

OperaOutlined.displayName = 'OperaOutlined';
export default React.forwardRef(OperaOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/OperaOutlined.js
// module id = 3179
// module chunks = 0